// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__MOFZ6","disclaimer":"Footer_disclaimer__fVccQ","version":"Footer_version__uZS0W"};